import React from 'react';
import { connect } from 'react-redux';

import { closeModal } from './modalDucks';

class Modal extends React.Component {


  onActionClick = (e) => {
    e.preventDefault();
    const {
      dispatch,
      modal: {
        action: {
          action,
        },
      },
    } = this.props;
    dispatch(closeModal());
    action();
  };

  onCancelClick = (e) => {
    e.preventDefault();
    const { dispatch } = this.props;
    dispatch(closeModal());
  };

  render() {
    const {
      modal: {
        hidden,
        action: {
          text,
          label,
        },
      },
    } = this.props;

    return (
      <div className={'modal ' + (hidden ? 'modal-close' : 'modal-open')}>
        <div className="modal-body">
          <p>{text}</p>
          <div className="btn-btm">
            <a
              className={'btn btn-default btn-gris'}
              onClick={this.onCancelClick}
            >
              Annuler
            </a>
            <a
              className={'btn btn-default btn-vert'}
              onClick={this.onActionClick}
            >
              {label}
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  modal: state.modal,
}))(Modal);



// WEBPACK FOOTER //
// ./book/src/commons/components/modal/Modal.jsx